<div class="sf-dt-pick" [class.is-disabled]="disabled">
  <div class="sf-dt-pick__field">
    <input
      type="date"
      class="form-control"
      [class.is-invalid]="!datePart && incompleteError"
      [min]="minDate"
      [ngModel]="datePart"
      (ngModelChange)="onDateChange($event)"
      [disabled]="disabled"
      [attr.data-testid]="testId ? testId + '-date' : null"
    />
  </div>
  <input
    type="time"
    step="60"
    class="form-control"
    [class.is-invalid]="timeError || (!timePart && incompleteError)"
    [min]="window.start"
    [max]="maxTime"
    [ngModel]="timePart"
    (ngModelChange)="onTimeChange($event)"
    [disabled]="disabled"
    [attr.aria-invalid]="timeError || (!timePart && incompleteError) ? 'true' : null"
    [attr.data-testid]="testId ? testId + '-time' : null"
  />
</div>
<div class="sf-dt-pick__error" *ngIf="fieldError" role="alert" [attr.data-testid]="testId ? testId + '-time-error' : null">
  {{ fieldError }}
</div>
<span class="sf-dt-pick__chip" *ngIf="window">
  Envios só das {{ window.start }} às {{ window.stop }} (horário de Brasília) · horários fora ficam bloqueados
</span>
